import { ActionReference, DefaultGameState, GameObjectReference, GameState } from "@shared/types";
import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { GameRouteService } from "../services/GameRouteService";
import { Page } from "../enums/Page";

/** CSS affecting the {@link CanvasComponent} */
const styles: string = css`

    :host {
        font-family: "Amatic SC", serif;
        font-weight: 10000;
        font-style: normal;
        width: 100%;
        height: 100%;
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: auto calc(35vh + 10px) minmax(calc(35vh + 10px), 1fr) auto;
        grid-column-gap: 0px;
        grid-row-gap: 0px;
        background-color: #17140d;
        color: aliceblue;
        cursor: url('/assets/img/UI/handCursor.png'), auto;
        transition: all 0.3s ease;
    }

    .title {
        position: fixed;
        text-align: center;
        bottom: 0;
        // margin-top: 10px;
        overflow: auto;
        background-color: transparent;
        z-index: 2;
        opacity: 0%;
        margin: 10px;
    }

    .header {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        height: 100vh;
        // margin-top: 5%;
    }

    .header img {
        width: auto;
        max-width: 1100px;
        height: 100vh;
        image-rendering: pixelated;
        z-index: 0;
        /* fade but keep UI */
        opacity: 1;
    }

    .header img:nth-child(n + 2) {
        position: absolute;
    }

    .content {
        // flex-grow: 1;
        overflow: auto;
        // margin-top: 10px;
        background-color: transparent;
        // display: none;
        line-break: auto;
        overflow-wrap: break-word;
        height: 100%;
        z-index: 6;
        margin: 50px 0 10px 0;
        padding: 0 15px 0 30px;
        width: calc(350px - 45px);
    }

    #paperRuffle {
        z-index: 0;
        position: fixed;
        top: 0;
        right: 0;
        object-fit: fill;
        height: 100vh;
        // min-height: 100vh;
        width: 350px;
        overflow: visible;
    }

    ::-webkit-scrollbar{
        display: none;
    }

    .content, .buttons {
        -ms-overflow-style: none;
        scrollbar-width: none;
    }


    .content p {
        margin: 0 0 10px 0;
    }

    .content p:last-of-type {
        margin: 0;
    }

    .footer {
        // background-color:rgb(139, 71, 137);
        // margin-top: 10px;
        display: flex;
        min-height: 180px;
        z-index: 6;
    }

    .footer .buttons {
        display: flex;
        flex-direction: column;
        overflow: auto;
        padding: 10px 10px 0 10px;
        width: 100%;
    }

    .footer .buttons div {
        display: flex;
        flex-direction: column;
    }

    .footer .button {
        padding-left: 5px;
        // margin: 0 0 10px 10px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        color: #79950b;
        z-index: 8;
    }

    .footer .button.active,
    .footer .button:hover {
        color: aliceblue;
        text-shadow: none;
        cursor: url('/assets/img/UI/handCursor.png'), auto;
    }

    .backgroundAndInvertory {
        background-color: #17140d;
        min-width: 736px;
        width: 100%
    }

    .textAndOptions {
        background-color: #17140d;
        background-color: transparent;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        width: fit-content;
        min-width: 350px;
        max-width: 350px;
        overflow: hidden;
    }

    .wreeves {
        display: flex;
        flex-direction: row;
        // align-items: center;
        max-height: 100vh;
        height: 100vh;
        /* fade full screen */
        opacity: 100%;
    }

    #optionsPatch {
        z-index: 8;
        position: fixed;
        bottom: -50px;
        right: 0;
        width: 360px;
        border-radius: 1px;
    }

    #topPatcher {
        z-index: 8;
        position: fixed;
        top: -140px;
        right: -13px;
        width: 370px;
    }

    .customCursor {
        position: absolute;
        top: 0;
        left: 0;
        display: none;
        z-index: 100;
    }

    #uItimer {
        position: fixed;
        top: 0;
        left: 0;
        // font-family: 'Courier New', monospace;
        font-size: 36px;
        margin: 10px;
        opacity: 70%;
    }

    #portraitFrame {
        position: fixed;
        top: -4px;
        right: 335px;
        z-index: 9;
        opacity: 0;
    }

    #portrait {
        height: 240px;
        position: absolute;
        right: 5px;
        z-index: -10;
        width: 160px;
    }

    #frame {
        height: 250px;
        z-index: 2;
    }

    #sanityMeter {
        display: flex;
        justify-content: flex-end;
        position: fixed;
        top: 0;
        right: 0;
        // background-color: green;
        z-index: 10;
        width: 330px;
        /* fade but keep basic ui */
    }

    #eye {
        height: 50px;
        z-index: 10;
    }

    #bar {
        height: 20px;
        position: absolute;
        top: 12px;
        right: 45px;
        z-index: 8;
        width: 200px;
        border-radius: 5px 0 0 5px;
    }

    #subBar {
        height: 20px;
        position: absolute;
        top: 10px;
        right: 45px;
        z-index: 7;
        width: 278.5px;
        border-radius: 5px 0 0 5px;
        border: solid 2px rgb(135, 128, 27);
    }

.playerInventory {
    position: fixed;
    left: 0;
    top: 60px;
    height: fit-content;
    width: fit-content;
    // background-color: rgb(130, 34, 73);
    margin-left: 10px;
        display: flex;
    flex-direction: column;
}

.playerInventory img {
    margin: 0;
    width: 60px;
    margin-bottom: 5px;
}

    .hungerVoice {
        color: rgb(183, 218, 27);
    }

    .egoVoice {
        color: rgb(246, 226, 13);
    }

    .paranoiaVoice {
        color: rgb(111, 207, 212);
    }
    .indulgenceVoice {
        color: rgb(255, 98, 0);
    }
    .reflectionVoice {
        color: rgb(142, 9, 137);
    }
    .hangedChefVoice {
        color: rgb(240, 195, 105);
    }
`;

/**
 * Represents the Canvas page
 */
export class CanvasComponent extends HTMLElement {
    /** Instance of the game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();
    /** Instance of the game route service */
    private readonly _gameRouteService: GameRouteService = new GameRouteService();

    /** Current game state */
    private _currentGameState?: DefaultGameState;
    /** Current active action button */
    private _selectedActionButton?: ActionReference;
    /** Current active game object buttons */
    private _selectedGameObjectButtons: Set<GameObjectReference> = new Set<GameObjectReference>();

    /**
     * The "constructor" of a Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        void this.refreshGameState();
    }

    /**
     * Refresh the current game state
     */
    private async refreshGameState(): Promise<void> {
        const state: GameState = await this._gameRouteService.getGameState();

        this.updateGameState(state);
    }

    /**
     * Update the canvas to the provided game state
     *
     * @param state Game state to update the canvas to
     */
    private updateGameState(state: GameState): void {
        // Handle switching pages, if requested.
        if (state.type === "switch-page") {
            this._gameEventService.switchPage(state.page as Page);

            return;
        }

        // Reset the component
        this._currentGameState = state;

        this._selectedActionButton = undefined;
        this._selectedGameObjectButtons.clear();

        // Refresh the web component
        this.render();
    }

    /**
     * Render the contents of this page
     */
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        let displaySanityBarWhenDefined: string = "style='opacity: 0;'";
        let sanity: number | undefined = this._currentGameState?.sanityLevel;
        if (sanity) {
            sanity *= 2.8;
            displaySanityBarWhenDefined = "style='opacity: 1;'";
        }

        let displayTimerWhenDefined: string = "style='opacity: 0;'";
        if (this._currentGameState?.timeLimit) {
            displayTimerWhenDefined = "style='opacity: 70%;'";
        }

        let displayPortraitWhenDefined: string = "style='opacity: 0;'";
        if (this._currentGameState?.visiblePortrait) {
            displayPortraitWhenDefined = "style='opacity: 1;'";
        }

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>
        <div class="fadeAllScreen"></div>
        <div class="wreeves">
            <div class="backgroundAndInvertory">
                ${this.renderTitle()}
                ${this.renderHeader()}
                <p id="uItimer" ${displayTimerWhenDefined}>${this._currentGameState?.timeLimit}</p>
                <div class="playerInventory">
                    ${this._renderInventory()}
                </div>
            </div>

            <div class="textAndOptions">
                <div id="portraitFrame" ${displayPortraitWhenDefined}>
                    <img id="frame" src="/assets/img/UI/woodFrame.png"/>
                    <img id="portrait" src="/assets/img/UI/${this._currentGameState?.visiblePortrait}"/>
                </div>

                <div id="sanityMeter" ${displaySanityBarWhenDefined}>
                    <img id="eye" src="/assets/img/UI/mindsEye.png"/>
                    <img id="bar" src="/assets/img/UI/sanityFluid.png" style="width: ${(sanity)}px;"/>
                    <img id="subBar" src="/assets/img/UI/sanityFluidGray.png"/>
                </div>

                <img id="topPatcher" src="/assets/img/UI/topPatcher.png"/>
                <img id="paperRuffle" src="/assets/img/UI/textbar.png"/>
                ${this.renderContent()}
                ${this.renderFooter()}
            </div>
        </div>
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
    }

    /**
     * Render the title element
     *
     * @returns String with raw HTML for the title element. Can be empty.
     */
    private renderTitle(): string {
        const roomName: string | undefined = this._currentGameState?.roomName;

        if (roomName) {
            return `<div class="title">${roomName}</div>`;
        }

        return "";
    }

    /**
     * Loop through inventory and places respective images in html
     *
     * @private
     * @return  {string}
     * @memberof CanvasComponent
     */
    private _renderInventory(): string {
        let inventoryHtml: string = "";
        if (typeof this._currentGameState?.inventory !== "undefined") {
            if (this._currentGameState.inventory.length < 1) {
                return inventoryHtml;
            }
            for (let index: number = 0; index < this._currentGameState.inventory.length; index++) {
                if (this._currentGameState.bucketFilled && this._currentGameState.inventory[index] === "Bucket") {
                    inventoryHtml += `
                        <img src="assets/img/UI/bucket-fill.png" alt="bucket-fill">
                    `;
                    continue;
                }
                inventoryHtml += `
                <img src="assets/img/UI/${this._currentGameState.inventory[index]}.png" alt="${this._currentGameState.inventory[index]}">
                `;
            }
        }
        return inventoryHtml;
    }

    /**
     * Render the header element
     *
     * @returns String with raw HTML for the header element. Can be empty.
     */
    private renderHeader(): string {
        const roomImages: string[] | undefined = this._currentGameState?.roomImages;
        let abugaba: string = "style='opacity: 0;'";
        if (this._currentGameState?.eyesAreOpen) {
            abugaba = "style='opacity: 1;'";
        }
        if (roomImages && roomImages.length > 0) {
            return `
                <div class="header">
                    ${roomImages.map(url => `<img src="/assets/img/rooms/${url}.png" ${abugaba} />`).join("")}
                </div>
            `;
        }

        return "";
    }

    /**
     * Render the content element
     *
     * @returns String with raw HTML for the content element
     */
    private renderContent(): string {
        return `
            <div class="content">
                ${this._currentGameState?.text.map(text => `<p>${text}</p>`).join("") || ""}
            </div>
        `;
    }

    /**
     * Render the footer element
     *
     * @returns HTML element of the footer
     */
    private renderFooter(): HTMLElement {
        return html`
            <div class="footer">
                <img id="optionsPatch" src="/assets/img/UI/leatherPatch.png"/>
                <div class="buttons">
                    <div>
                        ${this._currentGameState?.actions.map((button, index) => this.renderActionButton(button, index))}
                    </div>
                    <div>
                        ${this._selectedActionButton
                            ? this._currentGameState?.objects.map(button => this.renderGameObjectButton(button)) || ""
                            : ""
                        }
                    </div>
                </div>
            </div>
        `;
    }

    /**
     * Render an action button for a given action reference
     *
     * @returns HTML element of the action button
     */
    private renderActionButton(button: ActionReference, inputIndex: number): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedActionButton === button ? "active" : ""}">
               ${String(inputIndex + 1) + ".-"} ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickAction(button));

        return element;
    }

    /**
     * Render a game object button for a given game object reference
     *
     * @returns HTML element of the game object button
     */
    private renderGameObjectButton(button: GameObjectReference): HTMLElement {
        const element: HTMLElement = html`
            <a class="button ${this._selectedGameObjectButtons.has(button) ? "active" : ""}">
                ${button.name}
            </a>
        `;

        element.addEventListener("click", () => this.handleClickGameObject(button));

        return element;
    }

    /**
     * Handle the click on an action button
     *
     * @param button Action button that was clicked
     */
    private async handleClickAction(button: ActionReference): Promise<void> {
        // If this actions needs a game object, show the available game objects.
        if (button.needsObject) {
            this._selectedActionButton = button;
            this._selectedGameObjectButtons.clear();

            this.render();

            return;
        }

        // Otherwise, execute the action and update the game state.
        const state: GameState | undefined = await this._gameRouteService.executeAction(button.alias);

        if (state === undefined) {
            return;
        }

        this.updateGameState(state);
    }

    /**
     * Handle the click on a game object button
     *
     * @param button Game object button that was clicked
     */
    private async handleClickGameObject(button: GameObjectReference): Promise<void> {
        // If no action button was clicked, do not try to handle this click.
        if (!this._selectedActionButton) {
            return;
        }

        // Add the game object to list of selected game objects
        this._selectedGameObjectButtons.add(button);

        // Try to execute the action with all game objects on the list
        const state: GameState | undefined = await this._gameRouteService.executeAction(
            this._selectedActionButton.alias,
            [...this._selectedGameObjectButtons].map(e => e.alias)
        );

        // If 2 more game objects where on the list, clear it.
        if (this._selectedGameObjectButtons.size >= 2) {
            this._selectedActionButton = undefined;
            this._selectedGameObjectButtons.clear();
        }

        // Refresh the web component
        this.render();

        // If no state was returned, exit silently. This can happen when an action needs more than 1 game object.
        if (state === undefined) {
            return;
        }

        // Otherwise, update the game state.
        this.updateGameState(state);
    }
}
